export const FETCH_JOBS = 'FETCH_JOBS' as 'FETCH_JOBS';
export const FETCH_JOBS_SUCCESS = 'FETCH_JOBS_SUCCESS' as 'FETCH_JOBS_SUCCESS';
export const FETCH_JOBS_FAIL = 'FETCH_JOBS_FAIL' as 'FETCH_JOBS_FAIL';
export const FETCH_JOBS_CANCEL = 'FETCH_JOBS_CANCEL' as 'FETCH_JOBS_CANCEL';
export const CLEAR_JOBS = 'CLEAR_JOBS' as 'CLEAR_JOBS';

export const FETCH_JOBS_PAGE = 'FETCH_JOBS_PAGE' as 'FETCH_JOBS_PAGE';
